<!--
 * @Author: 仙道
 * @Date: 2022-08-14 00:34:04
 * @LastEditTime: 2022-08-14 00:42:12
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/alert/IotAlertListForPerson.vue
-->
<!--
 * @Author: 仙道
 * @Date: 2022-08-13 00:25:04
 * @LastEditTime: 2022-08-13 23:01:31
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/alert/IotAlertListForDetail.vue
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->

    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator">
      <a-tooltip title="卡片模式" v-show="!cardType">
        <a-button @click="cardType = true;" icon="credit-card" style="margin-left: 20px"></a-button>
      </a-tooltip>

      <a-tooltip title="表格模式" v-show="cardType">
        <a-button @click="cardType = false;" icon="table" style="margin-left: 20px" v-show="cardType"></a-button>
      </a-tooltip>
    </div>-->

    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>-->

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="levelSlot" slot-scope="alertLevel, item">
          <span v-if="item.alertLevel==1">
            <a-tag color="#ff4d4f">紧急告警</a-tag>
          </span>
          <span v-else-if="item.alertLevel==2">
            <a-tag color="#faad14">严重告警</a-tag>
          </span>
          <span v-else>
            <a-tag color="#52c41a">一般告警</a-tag>
          </span>
        </span>

        <span slot="recoverySlot" slot-scope="isRecovery, item">
          <a-tag color="#ff4d4f" v-if="item.isRecovery==0">未恢复</a-tag>
          <a-tag color="#52c41a" v-else>已恢复</a-tag>
        </span>

        <span slot="isAcknowledgementSlot" slot-scope="isAcknowledgement, item">
          <a-tag color="gray" v-if="item.isAcknowledgement==0">未确认</a-tag>
          <a-tag color="#52c41a" v-else>已确认</a-tag>
        </span>

        <span slot="action" slot-scope="text, record">
          <a :disabled="record.isAcknowledgement == 1" @click="acknowledgement(item)">确认</a>
          <a-divider type="vertical" />
          <a :disabled="record.isAcknowledgement == 1" @click="ignore(record)">忽略</a>
          <!-- <a :disabled="record.isAcknowledgement == 0">转工单</a>-->
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <!-- <a-menu-item>
                <a @click="ignore(record)">忽略</a>
              </a-menu-item>-->
              <a-menu-item>
                <a @click="devDetail(record)">设备详情</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="dataLine(record)">数据曲线</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="toOtherPage('/general/process')">工艺看板</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <def-register-modal @ok="registerModalFormOk" ref="registerModalForm"></def-register-modal>
    <points-line-chart-modal ref="pointsDataLineModal"></points-line-chart-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DefRegisterModal from '@views/equipment/defect/vue/modules/DefRegisterModal'
  import PointsLineChartModal from '@views/monitor/datas/modules/PointsLineChartModal'
  import devDefaulPng from '@/assets/dev.png'
  import processDefaulPng from '@/assets/process.jpg'
  import { httpAction, getAction } from '@/api/manage'
  import moment from 'dayjs'
  export default {
    name: 'IotAlertListPerson',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DefRegisterModal,
      PointsLineChartModal,
    },
    props: {
      query: {
        type: Object,
        default: () => { }
      }
    },
    data () {
      return {
        curItem: {},
        devDefaulPng: devDefaulPng,
        processDefaulPng: processDefaulPng,
        // superQueryParams: JSON.stringify([{ "rule": "=", "type": "string", "dictCode": "", "val": "0", "field": "disposal" }]),
        // 表头
        columns: [
          {
            title: '告警名称',
            align: 'center',
            dataIndex: 'devId_dictText'
          },
          {
            title: '告警时间',
            align: 'center',
            dataIndex: 'alertTime',
          },
          {
            title: '告警信息',
            align: 'center',
            dataIndex: 'summary'
          },
          {
            title: '是否确认',
            align: 'center',
            dataIndex: 'isAcknowledgement',
            scopedSlots: { customRender: 'isAcknowledgementSlot' }
          },
          {
            title: '处理方式',
            align: 'center',
            dataIndex: 'disposal_dictText'
          },
          {
            title: '是否恢复',
            align: 'center',
            dataIndex: 'isRecovery_dictText',
            scopedSlots: { customRender: 'recoverySlot' }
          },
          {
            title: '告警分类',
            align: 'center',
            dataIndex: 'alertType_dictText'
          },
          {
            title: '附件',
            align: 'center',
            dataIndex: 'attachment'
          },
          {
            title: '预警等级',
            align: 'center',
            dataIndex: 'alertLevel_dictText',
            scopedSlots: { customRender: 'levelSlot' }
          },
          {
            title: '测点点号',
            align: 'center',
            dataIndex: 'pointCode'
          },

        ],
        url: {
          list: '/alert/iotAlert/list',
          delete: '/alert/iotAlert/delete',
          edit: '/alert/iotAlert/edit',
          deleteBatch: '/alert/iotAlert/deleteBatch',
          exportXlsUrl: '/alert/iotAlert/exportXls',
          importExcelUrl: 'alert/iotAlert/importExcel'

        },
        cardType: true,
        dictOptions: {},
        superFieldList: [],
        queryParam: {},
        disableMixinCreated: true,
      }
    },
    created () {
      this.getSuperFieldList()
      this.queryParam = { ...this.query }
      this.loadData()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      },

      paginationProps () {
        const _this = this
        return {
          ..._this.ipagination,
          onChange (page, pageSize) {
            _this.ipagination.pageSize = pageSize
            _this.ipagination.current = page
            _this.loadData()
          }
        }
      },
    },
    methods: {
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams();// 查询条件
        if (params.summary) {
          params.summary = `*${params.summary}*`
        }
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
          this.loading = false
        })
      },
      devDetail (record) {
        this.$router.push({
          path: '/equipment/account/detail',
          query: {
            accountId: record.devId,
            pageType: 'text'
          }
        })
      },
      acknowledgement (record) {
        record.isAcknowledgement = 1;
        this.edit(record);
      },
      ignore (record) {
        record.isAcknowledgement = 1;
        record.disposal = 'ignore';
        this.edit(record);
      },
      edit (record) {
        httpAction(this.url.edit, record, 'put').then((res) => {
          if (res.success) {
            this.modalFormOk();
            this.$message.success('处理成功!')
          } else {
            that.$message.warning('处理失败!,请联系管理员');
          }
        })
      },
      dataLine (record) {
        const timeRange = [moment(record.alertTime).add(-1, 'hours').format('YYYY-MM-DD HH:mm'), moment(record.alertTime).add(1, 'hours').format('YYYY-MM-DD HH:mm')];
        const pointCode = record.pointCode;
        this.$refs.pointsDataLineModal.show(pointCode, timeRange);
      },
      defectRegister (record) {
        this.curItem = record;
        this.$refs.registerModalForm.add(record.devId)
        this.$refs.registerModalForm.title = '登记缺陷'
        this.$refs.registerModalForm.disableSubmit = false
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'int', value: 'groupId', text: '小组编号' })
        fieldList.push({ type: 'int', value: 'alertGroupId', text: '预警分组编号' })
        fieldList.push({ type: 'string', value: 'groupName', text: '小组名称' })
        fieldList.push({ type: 'string', value: 'alertName', text: '告警名称' })
        fieldList.push({ type: 'string', value: 'ruleId', text: '规则id' })
        fieldList.push({ type: 'string', value: 'pointCode', text: '测点点号' })
        fieldList.push({ type: 'string', value: 'devId', text: '传感器Sn码' })
        fieldList.push({ type: 'string', value: 'processId', text: '供水流域id' })
        fieldList.push({ type: 'date', value: 'alertTime', text: '告警时间' })
        fieldList.push({ type: 'string', value: 'summary', text: '告警信息' })
        fieldList.push({ type: 'int', value: 'alertType', text: '告警分类(测点采集、视频识别、音频识别)' })
        fieldList.push({ type: 'string', value: 'attachment', text: '附件文件id（图片、视频、音频等）' })
        fieldList.push({ type: 'int', value: 'alertLevel', text: '预警等级' })
        fieldList.push({ type: 'int', value: 'isAcknowledgement;', text: '是否被处理' })
        fieldList.push({ type: 'int', value: 'disposal', text: '处理方式' })
        fieldList.push({ type: 'int', value: 'isRecovery', text: '是否恢复' })
        this.superFieldList = fieldList
      },
      toOtherPage (route) {
        this.$router.push({
          path: route
        })
      },
      registerModalFormOk (defRegisterId) {
        console.log(defRegisterId)
        this.curItem.disposal = 'defect';
        this.edit(this.curItem);
      },
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

  .ant-card-meta-detail {
    overflow: hidden;
    height: 100px;
  }

</style>
